var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.11.996h5.228L7.2 5.543 4.005 8.152a10.57 10.57 0 0 0 3.877 3.858l2.564-3.15 4.542.862v5.128l-.972.109H14q-.44.035-.899.037C6.408 14.996.988 9.566.988 2.87q-.002-.572.052-1.15zM9.37 12.715a10.5 10.5 0 0 0 4.017.676v-2.344l-2.303-.438zM3.293 6.668 5.45 4.906l-.437-2.31H2.59q-.003.135-.003.274c0 1.34.25 2.62.705 3.798"
})));
export default SvgPhone;